import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { ArticlesService } from '../../../articles/core/ArticlesService';
import { IArticle, ITableResults } from '../../../../core/interfaces';
import { Subject } from 'rxjs';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import { AddEditArticleModalComponent } from '../../../../shared/modals/add-edit-article-modal/add-edit-article-modal.component';

@Component({
    selector: 'app-article-quick-search-chart',
    templateUrl: './article-quick-search-chart.component.html',
    styleUrl: './article-quick-search-chart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ArticleQuickSearchChartComponent {

  @ViewChild('modal') modal: AddEditArticleModalComponent;

  public articles: IArticle[] = [];
  public loading = false;
  public readonly search$ = new Subject<string>();

  private readonly _searchColumns = ['name', 'orderNumber', 'id'];
  private readonly _articlesService = inject(ArticlesService);
  private readonly _cdr = inject(ChangeDetectorRef);

  public constructor() {
    this.search$.pipe(
      debounceTime(300),
      tap(() => {
        this.loading = true;
        this._cdr.markForCheck();
      }),
      switchMap(val => {
        const trimmed = val.trim();
        let search = [];
        let additionalFilters = [];

        if (trimmed.length === 13 && !isNaN(+trimmed)) {
          additionalFilters = [{ key: 'ean', value: [trimmed] }];
        } else if (trimmed) {
          search = this._searchColumns.map(key => ({ key, value: [val] }));
        }

        return this._articlesService.getQueryableAll(1, 10, null, null, [], search, additionalFilters);
      })
    ).subscribe((res: ITableResults<IArticle>) => {
      this.articles = res.results;
      this.loading = false;
      this._cdr.markForCheck();
    });
  }
}
